import { useNavigate } from "react-router-dom";
import { Button } from "primereact/button";
import CustomBreadCrumbs from "../../../common/breadcrumbs";
import { useState, useMemo, useCallback } from "react";
import { useIntl } from "react-intl";
import { TabMenu } from "primereact/tabmenu";
import { Form, Field } from "react-final-form";
import { Message } from "primereact/message";

import { integrationSubtypesRequest } from "../../../../store/slices/integrationSlice";
import {
  TextInput,
  SwitchInput,
  DropdownInput,
  DropdownInputUF,
  DatePicker,
  TextInputNoti,
} from "../../../common/fields";
import Section from "../../../common/section";
import * as Validations from "../../../common/form/validator";
import { UploadCloud } from "react-feather"; // or any icon library
// import { CKEditor } from "@ckeditor/ckeditor5-react";
// import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { Checkbox } from "primereact/checkbox";
import { Dialog } from "primereact/dialog";
// import CustomEditor from './ckeditor';
import { Editor } from "@tinymce/tinymce-react";
import React, { useRef } from "react";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { ConfirmDialog } from "primereact/confirmdialog";
import AudienceUserList from "../../audiences/list"; // make sure path is correct
import UserList from "./UserList"; // make sure path is correct
import { PICKER_BASE_QUERY, useUserPicker } from "./useUserPicker";
import { useDispatch, useSelector } from "react-redux";
import { toZonedTime } from "date-fns-tz";
import {
  GetNotificationRequest,
  GetContentRequest,
  updateNotificationContentRequest,
  GetOthersCategoryRequest,
  CreateNotificationContentRequest,
  updateCustomNotiRecipant,
  CreateNotificationContentSuccess,
  GetNotificationClone,
  NotificationAlreadyExist,
  updateNotiBasicInfo,
} from "../../../../store/slices/notificationSlice";
import { listRequest } from "../../../../store/slices/usersSlice"; // ✅ correct action
import {
  dropdownRequest,
  getRolesRequest,
} from "../../../../store/slices/rolesSlice"; // ✅ correct action
import { listRequest as audienceListRequest } from "../../../../store/slices/audienceSlice";
import { setQuery as audSetQuery } from "../../../../store/slices/audienceSlice";
import { connect } from "react-redux";
import { use } from "react";
import { Calendar } from "primereact/calendar";
import "../../../../assets/css/rolesdialog.css";
import { listRequest as notificationList } from "../../../../store/slices/notificationSlice";
import { InputText } from "primereact/inputtext";
import { toast } from "react-toastify";
import { RouteConstants } from "../../../../constants";
import { DateTime } from "../../../common/list/ListCellRenders";
import { set, template } from "lodash";
import RoleList from "./RoleList"; // make sure path is correct
import { toRecipients } from "./useRecipientSelection";
import { isAiWriteAvailable, runAiWrite } from "./aiWrite";
import {
  joinAudience,
  splitAudience,
  useAudienceKinds,
} from "./audienceRecipients";
import CohortList from "./CohortList"; // make sure path is correct
import { useForm } from "react-final-form";
import { createPortal } from "react-dom";
import { LANGUAGES } from "../../../../constants/GlobalConstants";
import intl from "../../../../i18n/intl";
import { utc } from "dayjs";
import {
  defaultTimezone,
  fromExecutionDate,
  toExecutionDate,
} from "../../../../helpers/NotificationSchedule";

const customIntl = intl();

// Stable stand-ins while a list has not loaded: a new [] on every render
// would make every effect that depends on the list run on every render.
const NO_ROWS = [];
// Same idea for a single object: a new {} on every render while categories
// has not loaded yet made useSelector see a "changed" value on every render
// (its default equality check is ===), which re-ran the effect below that
// reads it, which called setLanguages with a new array, which re-rendered
// the component and read the selector again: an infinite render loop until
// GetOthersCategoryRequest's answer replaced the selected value.
const NO_CATEGORY = {};

const NotificationForm = ({
  labels,
  response = {},
  content = {},
  GetNotificationRequest,
  integrationSubtypesRequest,
  updateNotificationContentRequest,
  updateCustomNotiRecipant,
  updateNotiBasicInfo,
  GetContentRequest,
  updatedRecipant = {},
  newContentResponse = {},
  integrations = {},
  newUpadtedNotificationContent = {},
}) => {
  const navigate = useNavigate();
  const intl = useIntl();
  const [isEditable, setIsEditable] = useState(false);
  const [activeTab, setActiveTab] = useState(null);
  const [fileName, setFileName] = useState("");
  const [visible, setVisible] = useState(false);
  const [roles, setRoles] = useState([]);
  const [visibleCoh, setVisibleCoh] = useState(false);
  const [cohorts, setCohorts] = useState([]);
  const availableRoles = [
    "Learner",
    "Managers with Reports Permission",
    "SysRoot",
  ];
  const [prePopulatedUsers, setPrePopulatedUsers] = useState([]);
  const [prePopulatedCohorts, setPrePopulatedCohorts] = useState([]);
  const [prePopulatedRoles, setPrePopulatedRoles] = useState([]);
  // const [users, setUsers] = useState([]);
  const handleFileChange = (e) => {
    setFileName(e.target.files[0]?.name || "");
  };
  const [channels, setChannels] = useState({
    email: true,
    NotificationWidgets: true,
    sms: false,
    teams: false,
    whatsapp: false,
    messenger: false,
  });
  // const handleChange = (channel) => {
  //   if (["sms", "teams", "whatsapp", "messenger"].includes(channel)) return; // disable coming soon
  //   setChannels({ ...channels, [channel]: !channels[channel] });
  // };

  const handleChange = (channel, checked) => {
    setChannels((prev) => ({ ...prev, [channel]: checked }));
  };
  const channelList = [
    { key: "email", label: "Email" },
    { key: "NotificationWidgets", label: "Notification Widget" },
    { key: "sms", label: "SMS", comingSoon: true },
    { key: "teams", label: "MS Teams", comingSoon: true },
    { key: "whatsapp", label: "WhatsApp", comingSoon: true },
    { key: "messenger", label: "Messenger", comingSoon: true },
  ];
  const timezoneOptions = Intl.supportedValuesOf
    ? Intl.supportedValuesOf("timeZone").map((tz) => ({ name: tz, value: tz }))
    : [
        { name: "UTC", value: "UTC" },
        { name: "GMT", value: "GMT" },
        { name: "Asia/Kolkata", value: "Asia/Kolkata" },
        { name: "America/New_York", value: "America/New_York" },
      ];
  const urgencyOptions = [
    { name: "Normal", value: 0 },
    { name: "High Priority", value: 1 },
  ];
  const [notificationName, setNotificationName] = useState("");
  const [categoryName, setCategoryName] = useState("");
  const [urgencyFlag, setUrgencyFlag] = useState(0);
  const [subject, setSubject] = useState("");
  const [body, setBody] = useState("");
  const [from, setFrom] = useState("");
  const editorRef = useRef(null);
  const location = useLocation();
  const { isEdit } = location.state || {}; // fallback in case state is undefined
  const { isClone } = location.state || {}; // fallback in case state is undefined
  // What the persisted store held when this screen opened: the notification
  // and content kept from an earlier visit (for a clone, the notification as
  // it was before its last edit, or another notification). The edit and
  // clone screens load the notification again when they open, so only
  // answers that arrive after that are applied (F-BUG-13).
  const atOpen = useRef({ response, content });
  const [checked, setChecked] = useState(false); // state controls checkbox
  useEffect(() => {
    if (location.state?.activeTab !== undefined) {
      setActiveTab(location.state.activeTab);
    }
  }, [location.state]);
  const [languages, setLanguages] = useState([]);
  const [selectedLanguage, setSelectedLanguage] = useState("");
  const [notificationContents, setNotificationContents] = useState([]);
  const [suggestions, setSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [currentRange, setCurrentRange] = useState(null);
  const [placeholders, setPlaceholders] = useState([]);
  const [isUserListDialogVisible, setUserListDialogVisible] = useState(false); // Users Dialog
  const [showUsers, setShowUsers] = useState(false);
  const [showRoles, setShowRoles] = useState(false);
  // detect if we are in edit mode (from NotificationList edit button)
  const isEditMode = location.state?.isEdit || false;
  const isCustomEdit = location.state?.isCustomEdit || false;
  const id = location.state?.id;
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [audiences, setAudiences] = useState([]); // list of audience objects from backend api call
  const [selectedAudienceId, setSelectedAudienceId] = useState(null); // store selected audience
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [selectedRoles, setSelectedRoles] = useState([]);
  const [selectedCohorts, setSelectedCohorts] = useState([]);
  const [showCohorts, setShowCohorts] = useState(false);
  const [selectedCategoryId, setSelectedCategoryId] = useState([]);
  const [startTime, setStartTime] = useState("");
  const [startDate, setStartDate] = useState("");
  // M1 (phase2-P-UI-2-review): the admin's own browser zone, not a fixed
  // "Asia/Calcutta", so a notification the admin never touches the Timezone
  // dropdown for is sent at the typed time in their own zone.
  const [timezone, setTimezone] = useState(defaultTimezone());
  const [templates, setTemplates] = useState([]);
  const [transformed, setTransformed] = useState({});
  const reactQuilRef = useRef(null);

  let formState;
  const [errors, setErrors] = useState({
    notificationName: "",
    urgencyFlag: "",
    startDate: "",
    startTime: "",
    timezone: "",
  });
  const [touched, setTouched] = useState({
    notificationName: false,
    urgencyFlag: false,
    startDate: false,
    startTime: false,
    timezone: false,
  });
  const [disableTabSwitch, setDisableTabSwitch] = useState(true); // tabs cannot be switched
  const [highlightedIndex, setHighlightedIndex] = useState(-1);

  useEffect(() => {
    if (isEdit && isCustomEdit) {
      setNotificationName(newUpadtedNotificationContent?.name);
      setUrgencyFlag(newUpadtedNotificationContent?.urgencyFlag);
      setTimezone(newUpadtedNotificationContent?.timeZone);

      // The day and time in the notification's own time zone (F-BUG-14).
      const sendAt = fromExecutionDate(
        newUpadtedNotificationContent?.execuationDate,
        newUpadtedNotificationContent?.timeZone
      );

      setStartDate(sendAt.date);
      setStartTime(sendAt.time);

      formState?.change("start_date", sendAt.pickerDate);
      formState?.change("timezone", newUpadtedNotificationContent?.timeZone);
      setIsEditable(false);
    }
  }, [newUpadtedNotificationContent]);

  useEffect(() => {
    if (updatedRecipant && isCustomEdit && isEdit) {
      setPrePopulatedRoles(
        rolesData
          ?.map((u) =>
            (updatedRecipant?.audienceTo || []).includes(u.id) ? u.id : null
          )
          .filter(Boolean)
      );
      setPrePopulatedCohorts(
        audience?.list
          ?.map((u) =>
            (updatedRecipant?.audienceTo || []).includes(u.id) ? u.id : null
          )
          .filter(Boolean)
      );
      setPrePopulatedUsers(updatedRecipant?.userTo || []);
    }
  }, [updatedRecipant]);

  const EditableTabs = () => {
    if (isCustomEdit && isEdit) {
      return [0, 1, 2];
    } else {
      return [1];
    }
  };

  const validateTab0 = () => {
    const newErrors = {};

    if (!notificationName?.trim()) {
      newErrors.notificationName = "Notification Name is equired";
    }
    if (urgencyFlag === null || urgencyFlag === undefined) {
      newErrors.urgencyFlag = "Urgency Flag is required";
    }
    if (!startDate) {
      newErrors.startDate = "Notification Date is required";
    }
    if (!startTime) {
      newErrors.startTime = "Notification Time is required";
    }
    if (!timezone) {
      newErrors.timezone = "Timezone is required";
    }

    setErrors(newErrors);

    // Return true if valid
    return Object.keys(newErrors).length === 0;
  };

  const dispatch = useDispatch();

  // Users slice
  const users = useSelector((state) => state.users.data.list || NO_ROWS);
  const totalCount = useSelector((state) => state.users.data?.length || 0);
  // The Select Users dialog's own search (not usersSlice's query, E2E11)
  const { query, setQuery, fetchUsers } = useUserPicker(dispatch);

  var formattedUsers = useMemo(
    () =>
      users.map((user, idx) => ({
        id: user?.id || idx + 1,
        name:
          user.name || `${user.firstName || ""} ${user.lastName || ""}`.trim(), // combine firstName/lastName if needed
        email: user.email || "", // default to empty string if missing,
        value: false,
      })),
    [users]
  );
  


  // Initial fetch
  useEffect(() => {
    fetchUsers();
  }, [fetchUsers]);

  // AI Write runs through the API with the stored Gemini key (PX-2).
  const aiWriteAvailable = isAiWriteAvailable(integrations);

  const rolesData = useSelector(
    (state) => state.roles?.allRoles?.list || NO_ROWS
  );
  const totalCountRoles = useSelector(
    (state) => state.roles.allRoles?.list?.length || 0
  );
  const [queryRole, setQueryRole] = useState({
    search: "",
    pageNo: 1,
    pageSize: 10,
  });

  var formattedRoles = useMemo(
    () =>
      rolesData.map((role, idx) => ({
        id: role.id || idx + 1,
        name: role.name,
        userCount: role.userCount,
      })),
    [rolesData]
  );

  // fetchRoles like UserList example
  const fetchRoles = useCallback(
    (searchTerm = "") => {
      dispatch(
        getRolesRequest({
          query: { ...PICKER_BASE_QUERY, search: searchTerm },
        })
      );
    },
    [dispatch]
  );

  // Initial fetch
  useEffect(() => {
    fetchRoles();
  }, [fetchRoles]);

  // const audience = useSelector((state) => state.audiences.list || []);
  const totalCountAud = useSelector(
    (state) => state.audiences.data?.length || 0
  );
  // const queryAud = useSelector((state) => state.audiences.query || { search: "",pageNo: 1, pageSize: 50 });
  const [queryAud, setQueryAud] = useState({
    search: "",
    pageNo: 1,
    pageSize: 10,
  });

  const audience = useSelector((state) => state.audiences.data || NO_ROWS);

  // Which audience ids are roles and which are cohorts, as far as the lists
  // loaded since the screen opened tell (audienceRecipients.js).
  const audienceKinds = useAudienceKinds(rolesData, audience?.list);
  // A clone's role or cohort recipients whose kind no list loaded so far
  // tells: kept and saved with the clone (review M3).
  const [otherAudience, setOtherAudience] = useState([]);

 

  var formattedCohorts = useMemo(
    () =>
      audience.list?.map((aud, idx) => ({
        id: aud.id || idx + 1,
        name: aud.name,
        userCount: aud.userCount,
      })),
    [audience.list]
  );

  // fetchRoles like UserList example
  const fetchCohorts = useCallback(
    (searchTerm = "") => {
      dispatch(
        audienceListRequest({
          query: { ...PICKER_BASE_QUERY, search: searchTerm },
        })
      );
    },
    [dispatch]
  );

  // Initial fetch
  useEffect(() => {
    fetchCohorts();
  }, [fetchCohorts]);
  // console.log(formattedRoles, "roles----->>>>", rolesData);

  useEffect(() => {
    if (response === atOpen.current.response) {
      return;
    }
    if (isClone == true && response?.userTo) {
      // Every recipient of the original, also those not on the first page
      // of users loaded (they used to be dropped from the clone).
      setSelectedUsers(toRecipients(response.userTo, formattedUsers));
    }
  }, [isClone, response]);

  // A clone keeps every role and cohort recipient of the original, sorted
  // into roles and cohorts once, when the clone's answer arrives, as far as
  // the lists loaded so far tell; ids no list has shown yet are kept apart
  // (other) and still saved (review M3).
  //
  // selectedRoles and selectedCohorts are also the live selection of the
  // Roles and Cohorts dialogs. This used to run again whenever the role or
  // cohort list changed, until a dialog was saved, so a dialog's own search
  // (which reloads the list) put the original recipients back over the
  // boxes the admin had just ticked (code review phase 2, finding 1: F-BUG-5
  // on the clone screen). Like the edit screen, the clone is applied once per
  // answer and list loads never set the selection again.
  useEffect(() => {
    if (
      response === atOpen.current.response ||
      isClone != true ||
      !response?.audienceTo
    ) {
      return;
    }
    const split = splitAudience(response.audienceTo, audienceKinds);
    setSelectedRoles(toRecipients(split.roles, formattedRoles));
    setSelectedCohorts(toRecipients(split.cohorts, formattedCohorts));
    setPrePopulatedRoles(split.roles);
    setPrePopulatedCohorts(split.cohorts);
    setOtherAudience(split.other);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isClone, response]);

  // A role or cohort list that loads (or a dialog's search result) can tell
  // the kind of clone recipients that were not known yet: they move from
  // other to the roles or cohorts, added to what is already chosen. Nothing
  // chosen is replaced, so a list that no longer shows a recipient never
  // drops it, and the admin's own ticks stay.
  useEffect(() => {
    if (otherAudience.length === 0) {
      return;
    }
    const known = splitAudience(otherAudience, audienceKinds);
    if (known.roles.length === 0 && known.cohorts.length === 0) {
      return;
    }
    const addTo = (ids, rows) => (prev) => [
      ...prev,
      ...toRecipients(
        ids.filter((id) => !prev.some((item) => item.id === id)),
        rows
      ),
    ];
    setSelectedRoles(addTo(known.roles, formattedRoles));
    setSelectedCohorts(addTo(known.cohorts, formattedCohorts));
    setPrePopulatedRoles((prev) => joinAudience(prev, known.roles));
    setPrePopulatedCohorts((prev) => joinAudience(prev, known.cohorts));
    setOtherAudience(known.other);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rolesData, audience]);

  // Cancel (or closing) a Roles or Cohorts dialog puts its live selection
  // back to the recipients last saved, as on the edit screen; the ticks it
  // threw away were otherwise still sent with the notification.
  const cancelRoles = () => {
    setSelectedRoles(toRecipients(prePopulatedRoles, formattedRoles));
    setVisible(false);
  };
  const cancelCohorts = () => {
    setSelectedCohorts(toRecipients(prePopulatedCohorts, formattedCohorts));
    setVisibleCoh(false);
  };

  const handleSaveTab2 = (selectedUsers) => {
    setSelectedUsers(selectedUsers);
    // Do something with selectedUsers, e.g., update state or call API
    setShowUsers(false); // close the dialog
  };

  const handleSaveTab4 = (selectedCohorts) => {
    // console.log("Selected users:", selectedCohorts);
    setSelectedCohorts(selectedCohorts);
    // Do something with selectedUsers, e.g., update state or call API
    setVisibleCoh(false); // close the dialog
  };
  const handleSaveTab5 = (selectedRoles) => {
    // console.log("Selected users:", selectedRoles);
    setSelectedRoles(selectedRoles);
    // Do something with selectedUsers, e.g., update state or call API
    setVisible(false); // close the dialog
  };
  const handleSaveTab3 = (selectedCohorts) => {
    // console.log("Selected users:", selectedCohorts);
    setSelectedCohorts(selectedCohorts);
    // Do something with selectedUsers, e.g., update state or call API
    setShowCohorts(false); // close the dialog
  };
  // const categoryOptions = useSelector(
  //     (state) => state.notifications.categories|| []
  //   );

  //   // Dispatch API request once on mount
  //   useEffect(() => {
  //     dispatch(GetOthersCategoryRequest());
  //   }, [dispatch]);

  //   // Debug log
  //   useEffect(() => {
  //     console.log("Categories fetched ---->", categoryOptions);
  //   }, [categoryOptions]);

  const categoryData = useSelector(
    (state) => state.notifications.categories || NO_CATEGORY
  ); // single object

  const [categoryOptions, setCategoryOptions] = useState([]);

  // Dispatch API request once on mount
  useEffect(() => {
    dispatch(GetOthersCategoryRequest());
    integrationSubtypesRequest({
      type: 7,
      subtype: "Google_Gemini",
    });
  }, [dispatch]);

  // Update local state when Redux store updates
  useEffect(() => {
    if (categoryData && isEdit == false) {
      setCategoryName(categoryData.name);
      setSelectedCategoryId(categoryData.id);
      // setCategoryOptions(categoryData.placeHolders);
      setPlaceholders(categoryData.placeHolders);
      setLanguages(
        (categoryData.allowedLanguages || []).map((c) => ({
          code: c,
          name: getLanguageName(c),
        }))
      );
    }
  }, [categoryData]);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  // on first render, force Content tab if editing
  useEffect(() => {
    if (activeTab == null) {
      // only if not set yet
      if (isEditMode || isClone == true) {
        setActiveTab(0); // Force Content tab if editing
        fetchData(id);
        // console.log(activeTab, "activetab1->");
      } else if (location.state?.activeTab !== undefined) {
        setActiveTab(location.state.activeTab);
        // console.log(activeTab, "activetab------>");
      } else {
        setActiveTab(0); // default Basic Info
        // console.log(activeTab, "activetab0->");
      }
    }
  }, [isEditMode, location.state]);

  useEffect(() => {
    if (response === atOpen.current.response) {
      return;
    }
    if (
      isEdit == true &&
      isCustomEdit &&
      response &&
      response?.notificationContents
    ) {
      setNotificationName(response.name || "");
      setCategoryName(response.categoryName || "");
      // The day and the 24-hour time in the notification's own time zone
      // ("hh:mm" lost AM and PM, F-BUG-4; the browser's zone, F-BUG-14).
      const sendAt = fromExecutionDate(
        response.execuationDate,
        response.timeZone
      );

      setStartDate(sendAt.date);
      setStartTime(sendAt.time);

      setSelectedUsers(response.userTo || []);
      setPrePopulatedUsers(response.userTo || []);
      const prepopulatedCohorts = audience?.list
        ?.map((u) => ((response.audienceTo || []).includes(u.id) ? u.id : null))
        .filter(Boolean);
      // setSelectedCohorts(prepopulatedCohorts);
      setPrePopulatedCohorts(prepopulatedCohorts);
      const prepopulatedRoles = rolesData
        ?.map((u) => ((response.audienceTo || []).includes(u.id) ? u.id : null))
        .filter(Boolean);
      // setSelectedRoles(prepopulatedRoles);
      setPrePopulatedRoles(prepopulatedRoles);
      setSubject(
        response?.notificationContents?.find((c) => c.languageKey === "en")
          .subject || ""
      );

      setBody(
        response?.notificationContents?.find((c) => c.languageKey === "en")
          .body || ""
      );

      setUrgencyFlag(response?.urgencyFlag);

      setTimezone(response.timeZone || "");
      formState?.change("start_date", sendAt.pickerDate);
      formState?.change("timezone", response?.timeZone);
      setPlaceholders(response.placeHolders);
      setShowUsers(response.isUserRecepient || false);
      setLanguages(
        (response.allowedLanguage || []).map((c) => ({
          code: c,
          name: getLanguageName(c),
        }))
      );
      setSelectedLanguage("en");
      const channelArray = response.channel; // e.g. ["email", "NotificationWidgets"]

      // Convert to object matching your state shape
      const newChannels = channelList.reduce((acc, item) => {
        acc[item.key] = channelArray.includes(item.key);
        return acc;
      }, {});
      setChannels(newChannels);
    }
  }, [response, isCustomEdit]);

  useEffect(() => {
    if (isEdit && !isCustomEdit && !isClone && users) {
      setPrePopulatedUsers(users.map((u) => u.id));
    }
  }, [users]);

  useEffect(() => {
    if (response === atOpen.current.response) {
      return;
    }
    if (
      isEdit == true &&
      !isCustomEdit &&
      response &&
      response?.notificationContents
    ) {
      setNotificationName(response.name || "");
      setCategoryName(response.categoryName || "");
      setUrgencyFlag(response.urgencyFlag || "");
      setStartTime(response.execuationDate || "");
      setStartDate(response.execuationDate || "");
      setSubject(response?.notificationContents?.subject || "");
      setBody(response?.notificationContents?.body || "");
      setPlaceholders(response.placeHolders);
      setShowUsers(response.isUserRecepient || false);
      setLanguages(
        (response.allowedLanguage || []).map((c) => ({
          code: c,
          name: getLanguageName(c),
        }))
      );
      setSelectedLanguage("en");
      const channelArray = response.channel; // e.g. ["email", "NotificationWidgets"]

      // Convert to object matching your state shape
      const newChannels = channelList.reduce((acc, item) => {
        acc[item.key] = channelArray.includes(item.key);
        return acc;
      }, {});
      setChannels(newChannels);
    }
  }, [response]);

  useEffect(() => {
    if (response === atOpen.current.response) {
      return;
    }
    if (!isEdit && isClone && response && response.notificationContents) {
     
      setNotificationName(isClone ? "" : response?.name ?? "");
      setCategoryName(response?.categoryName ?? "");
      setUrgencyFlag(response?.urgencyFlag ?? 0);
      setSubject(
        response?.notificationContents?.find((n) => n.languageKey === "en")
          .subject ?? ""
      );
      setBody(
        response?.notificationContents?.find((n) => n.languageKey === "en")
          .body ?? ""
      );
      setPlaceholders(response?.placeHolders ?? []);
      setShowUsers(response?.isUserRecepient ?? false);
      setTemplates(response?.notificationContents ?? []);
      setLanguages(
        (response?.allowedLanguage ?? []).map((c) => ({
          code: c,
          name: getLanguageName(c),
        }))
      );
      setSelectedLanguage("en");

      setPrePopulatedUsers(response.userTo || []);
      // The clone's roles and cohorts: see the effect after the clone's
      // users above.
      // setSelectedUsers(
      //   (response?.userTo ?? [])
      //     .map((id) => formattedUsers?.find((u) => u.id === id))
      //     .filter(Boolean)
      // );
      // setPrePopulatedUsers(response.userTo);

      // formattedUsers = formattedUsers.map((user) =>
      //   selectedUsers.some((u) => u.id === user.id)
      //     ? { ...user, value: true }
      //     : user
      // );
      // setSelectedCohorts(
      //   (response?.audienceTo ?? [])
      //     .map((id) => formattedCohorts.find((u) => u.id === id))
      //     .filter(Boolean)
      // );
      // setPrePopulatedCohorts(response?.audienceTo);
      // formattedCohorts = formattedCohorts.map((cohort) =>
      //   selectedCohorts.some((u) => u.id === cohort.id)
      //     ? { ...cohort, value: true }
      //     : cohort
      // );
      const channelArray = response.channel;

      // Convert to object matching your state shape
      const newChannels = channelList.reduce((acc, item) => {
        acc[item.key] = channelArray.includes(item.key);
        return acc;
      }, {});
      setChannels(newChannels);
    }
  }, [response, isClone]);

  useEffect(() => {
    if (content && content !== atOpen.current.content) {
      setSubject(content.subject || "");
      setBody(content.body || "");
    }
  }, [content]);

  useEffect(() => {
    setTransformed(
      LANGUAGES.reduce((acc, lang) => {
        acc[lang.code] = lang;
        return acc;
      }, {})
    );
  }, []);

  const getLanguageName = (key) => {
    const mapping = {
      de: "German",
      en: "English",
      "fr-CA": "French (Canada)",
      mn: "Mongolian",
      ru: "Russian",
      id: "Indonesian",
      "es-LA": "Spanish (Latin America)",
      es: "Spanish",
    };

    if (!mapping[key]) {
      return transformed[key]?.name;
    }
    return mapping[key] || key;
  };

  const fetchData = (id) => {
    if (isClone === true || isCustomEdit) {
      response = {};
      dispatch(GetNotificationClone({ id: id }));
    } else {
      GetNotificationRequest({ id: id });
      GetContentRequest({ id: id, key: "en" });
    }
  };

  const handleLanguageChange = (e, formProps) => {
    const langCode = e;

    setSelectedLanguage(langCode);
    setSubject("");
    setBody("");
    formProps.form.change("subject", "");

    if (isEdit == false) {
      if (isClone == true) {
        // GetContentRequest({ id: response.id, key: e });
        formProps.form.change("subject", subject);
      }
      if (subject != "" && body != "") {
        let editorContentData = editorRef.current.getContent();
        if (
          formProps.values.language != "" &&
          formProps.values.subject != "" &&
          editorContentData != ""
        ) {
          const editorContent = editorRef.current ? editorContentData : body;
          const timestamp = new Date().toISOString(); // e.g., "2025-10-08T08:27:07.370Z"
          const foundTemplate =
            templates.length > 0
              ? templates.find(
                  (t) => t.languageKey == formProps.values.language
                )
              : {};
          if (foundTemplate) {
            setTemplates(
              templates.filter(
                (t) => t.languageKey !== foundTemplate.languageKey
              )
            );
          }

          // Create object
          const templateObject = {
            languageKey: formProps.values.language,
            subject: formProps.values.subject,
            body: editorContent,
            createdAt: timestamp,
            updatedAt: timestamp,
          };
          // Push to array (state)
          setTemplates((prevTemplates) => [...prevTemplates, templateObject]);
        }
      }

      const foundTemplate =
        templates.length > 0
          ? templates.find((t) => t.languageKey == langCode)
          : {};
      if (foundTemplate) {
        setSubject(foundTemplate.subject || "");
        formProps.form.change("subject", foundTemplate.subject || "");
        setBody(foundTemplate.body || "");
      }
    }
    if (isEdit == true) {
      // console.log(formProps);
      GetContentRequest({ id: response.id, key: e });
      formProps.form.change("subject", subject);
    }
  };

  const handleUrgencyFlag = (e) => {
    setUrgencyFlag(e.name == "Normal" ? 0 : 1);
  };
  const handleTabChange = (index) => {
    if (index === 2 && isCustomEdit) {
      setPrePopulatedUsers(response.userTo || []);
      const prepopulatedCohorts = audience?.list
        ?.map((u) => ((response.audienceTo || []).includes(u.id) ? u.id : null))
        .filter(Boolean);
      // setSelectedCohorts(prepopulatedCohorts);
      setPrePopulatedCohorts(prepopulatedCohorts);
      const prepopulatedRoles = rolesData
        ?.map((u) => ((response.audienceTo || []).includes(u.id) ? u.id : null))
        .filter(Boolean);
      // setSelectedRoles(prepopulatedRoles);
      setPrePopulatedRoles(prepopulatedRoles);
    }
    setActiveTab(index);
    setIsEditable(false); // reset edit mode on tab switch
  };

  const handleSaveNotification = () => {
    const userIds = selectedUsers.map((user) => String(user.id));
    const cohortsIds = selectedCohorts.map((cohort) => String(cohort.id));
    const rolesIds = selectedRoles.map((role) => String(role.id));
    const timestamp = new Date().toISOString(); // e.g., "2025-10-08T08:27:07.370Z"

    const data = {
      Name: notificationName,
      CategoryId: selectedCategoryId,
      urgencyFlag: urgencyFlag, //urgencyFlag, temporirily giving 0 as value because dropdown options have not finalized yet
      PlaceHolders: placeholders,
      UserRecepient: userIds,
      AudienceTo: joinAudience(rolesIds, cohortsIds, otherAudience),
      Channel: Object.keys(channels).filter((key) => channels[key]),
      NotificationContents: templates,
      // [{
      //   subject: subject,
      //   body: body,
      //   languageKey: selectedLanguage || "en",
      //   createdAt: timestamp,
      //   updatedAt: timestamp
      // }],
      IsEnabled: true,
      frequency: 1,
      IsSystemGenerated: false,
      // startDate:startDate, // you can pick the value from DatePicker field
      // startTime:startTime, // from time field
      // The chosen day and time in the chosen time zone; it was built in the
      // admin's browser zone, so the notification went out at that time in
      // the browser's zone (F-BUG-14).
      ExecuationDate: toExecutionDate(startDate, startTime, timezone),
      TimeZone: timezone, // from dropdown
    };
    // Check for English content before proceeding
    const englishTemplate = templates.find(
      (t) =>
        t.languageKey === "en" &&
        t.body?.trim() !== "" &&
        t.subject?.trim() !== ""
    );

    if (!englishTemplate) {
      toast.error(
        customIntl.formatMessage({
          id: "validation_for_Content",
        })
      );
      return;
    }

    dispatch(CreateNotificationContentRequest({ data: data }));
    //dispatch({ type: "notifications/CreateNewNotification", payload: { data } });
  };

  useEffect(() => {
    if (newContentResponse && newContentResponse.success) {
      navigate(RouteConstants.APP_ROUTE_NOTIFICATIONS_BUILDER_LIST);
    }
  }, [newContentResponse]);

  const addTemplateToList = (formProps) => {
    let editorContentData = editorRef.current.getContent();
    if (
      formProps.values.language != "" &&
      formProps.values.subject != "" &&
      editorContentData != ""
    ) {
      const editorContent = editorRef.current ? editorContentData : body;
      const timestamp = new Date().toISOString(); // e.g., "2025-10-08T08:27:07.370Z"
      const foundTemplate =
        templates.length > 0
          ? templates.find((t) => t.languageKey == formProps.values.language)
          : {};
      if (foundTemplate) {
        setTemplates(
          templates.filter((t) => t.languageKey !== foundTemplate.languageKey)
        );
      }
      // Create object
      const templateObject = {
        languageKey: formProps.values.language,
        subject: formProps.values.subject,
        body: editorContent,
        createdAt: timestamp,
        updatedAt: timestamp,
      };

      formProps.form.change("subject", "");
      formProps.form.change("language", "");

      // Push to array (state)
      setTemplates((prevTemplates) => [...prevTemplates, templateObject]);

      setSubject("");
      setSelectedLanguage("");
      setBody("");

      // Reset editor content
      if (editorRef.current) {
        editorRef.current.setContent(""); // clear TinyMCE editor
      }
    }
  };

  const notiStatus = useSelector(
    (state) => state.notifications.notiStatus || NO_CATEGORY
  );
  const requesting = useSelector((state) => state.notifications.requesting);

  const handleNotificationNameChange = (value) => {
    // console.log(notiStatus.notiStatus.response,"notistati1")
    setNotificationName(value);
    //  dispatch({
    //   type: "notifications/ResetNotificationStatus",
    // });
    if (value.trim() !== "") {
      dispatch({
        type: "notifications/NotificationAlreadyExist",
        payload: { templateName: value},
      });
    }
  };

  useEffect(() => {
    dispatch({ type: "notifications/ResetNotificationStatus" });
  }, [dispatch]);

  const [filteredSuggestions, setFilteredSuggestions] = useState([]);

  const handleSubjectChange = (e, formProps) => {
    // console.log(e, "e val---->>>");
    const value = e;
    setSubject(value);
    formProps.form.change("subject", value);
    // Show suggestions when user types "{"

    const splitedArr = value.trim().split(" ").reverse();

    for (let i = 0; i < splitedArr.length; i++) {
      const regEx = /^\{[a-zA-Z]*$/;
      if (regEx.test(splitedArr[i]) && splitedArr[i] != " ") {
        setFilteredSuggestions(placeholders);
        setShowSuggestions(true);
        i = splitedArr.length;
      } else {
        setShowSuggestions(false);
      }
    }

    if (showSuggestions) {
      const match = value.split("{").pop().toLowerCase();
      const filtered = placeholders.filter((p) =>
        p.toLowerCase().includes(match)
      );
      setFilteredSuggestions(filtered);
      if (filtered.length === 0) setShowSuggestions(false);
    }
  };

  const selectSuggestion = (sugg) => {
    const newValue = subject.replace(/\{[^{}]*$/, `{{${sugg}}}`);
    setSubject(newValue);
    setShowSuggestions(false);
  };

  const inputWrapperRef = useRef(null); // wrapper around Formik Field
  const [dropdownPos, setDropdownPos] = useState({ top: 0, left: 0, width: 0 });
  const dropdownRef = useRef(null);
  const itemRefs = useRef([]);

  // helper: find nearest scrollable ancestor
  const getScrollParent = (node) => {
    if (!node) return window;
    let parent = node.parentElement;
    while (parent) {
      const style = window.getComputedStyle(parent);
      const overflowY = style.overflowY;
      const isScrollable =
        overflowY &&
        (overflowY === "auto" ||
          overflowY === "scroll" ||
          overflowY === "overlay");
      if (isScrollable && parent.scrollHeight > parent.clientHeight)
        return parent;
      parent = parent.parentElement;
    }
    return window;
  };

  const handleKeyDown = (e) => {
    if (!showSuggestions) return;

    if (e.key === "ArrowDown") {
      e.preventDefault();
      setHighlightedIndex((prev) =>
        prev < filteredSuggestions.length - 1 ? prev + 1 : 0
      );
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      setHighlightedIndex((prev) =>
        prev > 0 ? prev - 1 : filteredSuggestions.length - 1
      );
    } else if (e.key === "Enter") {
      e.preventDefault();
      if (highlightedIndex >= 0) {
        selectSuggestion(filteredSuggestions[highlightedIndex]);
      }
    } else if (e.key === "Escape") {
      setShowSuggestions(false);
    }
  };

  useEffect(() => {
    if (highlightedIndex >= 0 && itemRefs.current[highlightedIndex]) {
      itemRefs.current[highlightedIndex].scrollIntoView({
        block: "nearest",
        behavior: "smooth",
      });
    }
  }, [highlightedIndex]);

  const calculatePosition = useCallback(() => {
    const el = inputWrapperRef.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    // use page coordinates since portal is in document.body and we use absolute positioning
    setDropdownPos({
      top: rect.bottom + window.scrollY, // absolute page Y
      left: rect.left + window.scrollX, // absolute page X
      width: rect.width,
    });
  }, []);

  useEffect(() => {
    if (!showSuggestions) return; // only active when dropdown visible

    // measure immediately when opening
    calculatePosition();

    const scrollParent = getScrollParent(inputWrapperRef.current);
    // handlers
    const onScroll = () => calculatePosition();
    const onResize = () => calculatePosition();
    const onKey = (e) => {
      if (e.key === "Escape") {
        // close dropdown, make sure you control showSuggestions from state
        // setShowSuggestions(false);
      }
    };

    const onDocClick = (e) => {
      // close when click outside input or dropdown
      if (
        inputWrapperRef.current &&
        !inputWrapperRef.current.contains(e.target) &&
        dropdownRef.current &&
        !dropdownRef.current.contains(e.target)
      ) {
        // setShowSuggestions(false);
      }
    };

    // attach scroll listener to the nearest scrollable parent (or window)
    if (scrollParent === window) {
      window.addEventListener("scroll", onScroll, { passive: true });
    } else {
      scrollParent.addEventListener("scroll", onScroll, { passive: true });
    }
    window.addEventListener("scroll", onScroll, { passive: true }); // in case page scrolls too
    window.addEventListener("resize", onResize);
    document.addEventListener("keydown", onKey);
    document.addEventListener("click", onDocClick);

    // optional: observe size changes of input wrapper (e.g., responsive layout)
    let resizeObserver;
    if (window.ResizeObserver && inputWrapperRef.current) {
      resizeObserver = new ResizeObserver(() => calculatePosition());
      resizeObserver.observe(inputWrapperRef.current);
    }

    return () => {
      if (scrollParent === window) {
        window.removeEventListener("scroll", onScroll);
      } else {
        scrollParent.removeEventListener("scroll", onScroll);
      }
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onResize);
      document.removeEventListener("keydown", onKey);
      document.removeEventListener("click", onDocClick);
      if (resizeObserver && inputWrapperRef.current)
        resizeObserver.unobserve(inputWrapperRef.current);
    };
  }, [showSuggestions, calculatePosition]);

  const recipants = useSelector((state) => state.notifications?.record);

  useEffect(() => {
    function handleListner(e) {
      if (dropdownRef) {
        if (!dropdownRef?.current?.contains(e.target)) {
          setShowSuggestions(false);
        }
      }
    }
    document.body.addEventListener("pointerdown", handleListner);
    return () => {
      document.body.removeEventListener("pointer", handleListner);
    };
  }, []);

  // also recalc position whenever filteredSuggestions changes (optional)
  useEffect(() => {
    if (showSuggestions) calculatePosition();
  }, [filteredSuggestions, showSuggestions, calculatePosition]);

  const [calendarKey, setCalendarKey] = useState(0);

  useEffect(() => {
    // Every time we enter edit mode (or switch to tab 0) → new key
    if (isEditMode && activeTab === 0) {
      setCalendarKey((prev) => prev + 1);
    }
  }, [isEditMode, activeTab]);

  useEffect(() => {
    if (!isEdit  && !isClone && activeTab === 1) {
      const lang = templates.filter(
        (template) => template.languageKey === "en"
      );
      if (lang.length > 0) {
        setSelectedLanguage("en");
        setSubject(lang[0].subject);
        setBody(lang[0].body);
      } else {
        setSubject("");
        setBody("");
      }
    } else if (!isEdit && !isCustomEdit && isClone && activeTab === 1) {
      const lang = templates.filter(
        (template) => template.languageKey === "en"
      );

      if (lang.length > 0) {
        setSelectedLanguage("en");
        formState.change("language", "en");
        setSubject(lang[0].subject);
        setBody(lang[0].body);
      } else {
        setSubject("");
        setBody("");
      }
    }
  }, [activeTab]);


  return (
    <div>
      <CustomBreadCrumbs
        labels={[
          { label: "Notifications", to: "/notifications" }, // Parent page
          { label: isEdit ? `${notificationName}` : "add_new_notification" }, // Current page
        ]}
        navigate={navigate}
      />

      <div className="edexlms-page-content">
        <div className="edexlms-page-header">
          <div className="edexlms-page-title">
            {/* {intl.formatMessage({ id: "add_new_notification" })} */}
            {isEditMode
              ? intl.formatMessage({ id: "edit_notification" })
              : intl.formatMessage({ id: "add_new_notification" })}
          </div>
          {(isEditMode || isCustomEdit) &&
            EditableTabs()?.includes(activeTab) && (
              <Button
                label={intl.formatMessage({ id: "edit" })}
                icon="pi pi-pencil"
                className="p-button-sm p-button-outlined"
                onClick={() => setIsEditable(true)}
              />
            )}
        </div>

        <div
          className="edexlms-page-body"
          style={{
            height: "calc(100vh - 64px - 20px - 45px - 40px - 14px - 40px)",
            overflowY: "scroll",
          }}
        >
          {activeTab !== null && (
            <TabMenu
              className="edexlms-tab-menu"
              model={[
                {
                  label: intl.formatMessage({ id: "basic_info" }),
                  // disabled: isEditMode, // ✅ disable in edit mode
                  // command: () => {
                  //   if (activeTab !== 0) {
                  //     setActiveTab(0);
                  //     setIsEditable(false);
                  //   }
                  // },
                  command: () => {
                    if (isEditMode) handleTabChange(0);
                  },
                },
                {
                  label: intl.formatMessage({ id: "content" }),
                  // command: () => {
                  //   if (activeTab !== 1) {
                  //     setActiveTab(1);
                  //     setIsEditable(false);
                  //   }
                  // },
                  command: () => {
                    if (isEditMode) handleTabChange(1);
                  },
                },
                {
                  label: intl.formatMessage({ id: "recipient" }),
                  // disabled: isEditMode, // ✅ disable in edit mode
                  // command: () => {
                  //   if (activeTab !== 2) {
                  //     setActiveTab(2);
                  //     setIsEditable(false);
                  //   }
                  // },
                  command: () => {
                    if (isEditMode) handleTabChange(2);
                  },
                },
                {
                  label: intl.formatMessage({ id: "channels" }),
                  // disabled: isEditMode, // ✅ disable in edit mode
                  // command: () => {
                  //   if (activeTab !== 3) {
                  //     setActiveTab(3);
                  //     setIsEditable(false);
                  //   }
                  // },
                  command: () => {
                    if (isEditMode) handleTabChange(3);
                  },
                },
              ]}
              activeIndex={activeTab} // ✅ bind active tab
              onTabChange={(e) => {
                if (isEditMode) setActiveTab(e.index);
              }}
            />
          )}

          {/* ✅ Wrap fields inside Form */}
          <Form
            onSubmit={(values) => {
              if (activeTab === 0 && isCustomEdit) {
                updateNotiBasicInfo({
                  data: {
                    NotificationId: response.id,
                    Name: notificationName,
                    CategoryId: categoryData.id,
                    UrgencyFlag: urgencyFlag,
                    ExecuationDate: toExecutionDate(
                      startDate,
                      startTime,
                      timezone
                    ),
                    TimeZone: timezone,
                  },
                });
                
              } else if (activeTab === 1 && isEditMode) {
                const data = {
                  Id: content?.id ? content.id : response.id,
                  LanguageKey: values.language,
                  Body: editorRef.current
                    ? editorRef.current.getContent()
                    : body,
                  Subject: subject,
                  NotificationId: response.id,
                };
                if (
                  data.LanguageKey === "en" &&
                  (!data.Body || data.Body.trim() === "")
                ) {
                  toast.error(
                    customIntl.formatMessage({
                      id: "validation_for_Content",
                    })
                  );
                  return;
                }
                updateNotificationContentRequest({ data: data });
                setIsEditable(false);
              } else if (activeTab === 2 && isCustomEdit && isEditable) {
                updateCustomNotiRecipant({
                  data: {
                    NotificationId: response.id,
                    UserRecepient: [...prePopulatedUsers],
                    AudienceTo: [...prePopulatedCohorts, ...prePopulatedRoles],
                  },
                });

                setIsEditable(false);
              }
            }}
            render={(formikProps) => {
              const { handleSubmit, form, values } = formikProps; // destructure form from it
              formState = form;
              return (
                <form onSubmit={formikProps.handleSubmit}>
                  {activeTab === 0 && (
                    <div className="flex flex-column gap-4 relative">
                      {isEditMode && !isEditable ? (
                        // ---------------- Edit Mode ----------------
                        <div className="flex flex-column gap-3 border-round p-2">
                          <Section title="general">
                            <div className="flex flex-column gap-2">
                              <div className="grid">
                                {/* Name */}
                                <div className="col-12 md:col-6 lg:col-4">
                                  <label
                                    className="text-gray-500"
                                    style={{
                                      fontColor: "#64748b",
                                      fontSize: "12px",
                                      fontWeight: "400",
                                    }}
                                  >
                                    {intl.formatMessage({ id: "name" })}
                                  </label>
                                  <div className="text-gray-600 mt-1">
                                    {/* {apiData?.name || "-"} */}
                                    {/* {"Shivani"} */}
                                    {notificationName || "-"}
                                  </div>
                                </div>

                                {/* Category */}
                                <div className="col-12 md:col-6 lg:col-4">
                                  <label
                                    className="text-gray-500"
                                    style={{
                                      fontColor: "#64748b",
                                      fontSize: "12px",
                                      fontWeight: "400",
                                    }}
                                  >
                                    {intl.formatMessage({ id: "category" })}
                                  </label>
                                  <div className="text-gray-600 mt-1">
                                    {/* {apiData?.category || "-"} */}
                                    {/* {"Program"} */}
                                    {categoryName || "-"}
                                  </div>
                                </div>
                                {/* urgency flag */}
                                <div className="col-12 md:col-6 lg:col-4">
                                  <label
                                    className="text-gray-500"
                                    style={{
                                      fontColor: "#64748b",
                                      fontSize: "12px",
                                      fontWeight: "400",
                                    }}
                                  >
                                    {intl.formatMessage({ id: "urgency_flag" })}
                                  </label>
                                  <div className="text-gray-600 mt-1">
                                    {/* {apiData?.category || "-"} */}
                                    {/* {"Program"} */}
                                    {isCustomEdit
                                      ? urgencyFlag === 0
                                        ? "Normal"
                                        : "High Priority"
                                      : "Normal"}
                                  </div>
                                </div>
                                <>
                                  {isCustomEdit && (
                                    <>
                                      <div className="col-12 md:col-6 lg:col-4">
                                        <label
                                          className="text-gray-500"
                                          style={{
                                            fontColor: "#64748b",
                                            fontSize: "12px",
                                            fontWeight: "400",
                                          }}
                                        >
                                          {intl.formatMessage({
                                            id: "notification_date",
                                          })}
                                        </label>
                                        <div className="text-gray-600 mt-1">
                                          {/* {apiData?.category || "-"} */}
                                          {/* {"Program"} */}
                                          {/* {startDate && new Date(startDate) } */}
                                          {startDate}
                                        </div>
                                      </div>
                                      <div className="col-12 md:col-6 lg:col-4">
                                        <label
                                          className="text-gray-500"
                                          style={{
                                            fontColor: "#64748b",
                                            fontSize: "12px",
                                            fontWeight: "400",
                                          }}
                                        >
                                          {intl.formatMessage({
                                            id: "notification_time",
                                          })}
                                        </label>
                                        <div className="text-gray-600 mt-1">
                                          {/* {apiData?.category || "-"} */}
                                          {/* {"Program"} */}
                                          {`${startTime}`}
                                        </div>
                                      </div>
                                      <div className="col-12 md:col-6 lg:col-4">
                                        <label
                                          className="text-gray-500"
                                          style={{
                                            fontColor: "#64748b",
                                            fontSize: "12px",
                                            fontWeight: "400",
                                          }}
                                        >
                                          {intl.formatMessage({
                                            id: "timezone",
                                          })}
                                        </label>
                                        <div className="text-gray-600 mt-1">
                                          {/* {apiData?.category || "-"} */}
                                          {/* {"Program"} */}
                                          {timezone}
                                        </div>
                                      </div>
                                    </>
                                  )}
                                </>
                              </div>
                            </div>
                          </Section>
                        </div>
                      ) : (
                        <div className="flex flex-column gap-4">
                          {/* ---------------- Name ---------------- */}

                          <div className="col-12 flex flex-column gap-2">
                            <label htmlFor="name">
                              {intl.formatMessage({ id: "name" })}
                            </label>
                            <Field
                              id="name"
                              name="name"
                              initialValue={notificationName}
                              component={TextInputNoti}
                              type="text"
                              placeholder={intl.formatMessage({
                                id: "enter_template_name",
                              })}
                              // onChange={(e)=> {
                              //   console.log(e,"evalue----->>>")
                              //   setNotificationName(e.target.value)}}
                              // onChange={(e) => setNotificationName(e?.value ?? e?.target?.value ?? "")}
                              onChange={(value) => {
                                setNotificationName(value);
                                handleNotificationNameChange(value);
                              }} // value is already the input value
                              required
                              validate={Validations.composeValidators(
                                Validations.required
                              )}
                              style={{ width: "100%" }}
                            />
                            {requesting && <small>Checking name...</small>}
                            {notiStatus?.notiStatus?.response === true && (
                              <div
                                class="edexlms-field-error"
                                style={{ color: "#d9342b" }} // only override color
                              >
                                Notification name already exists
                              </div>
                            )}
                          </div>

                          {/* ---------------- Category + Urgency Flag in Same Row ---------------- */}
                          <div className="flex flex-row gap-4 w-full">
                            <div
                              className="col-12 md:col-6 flex flex-column gap-2"
                              style={{ width: "50%" }}
                            >
                              <label>
                                {intl.formatMessage({ id: "category" })}
                              </label>

                              <Field
                                name="category"
                                component={TextInputNoti}
                                value="Others"
                                input={{
                                  value: "Others",
                                  readOnly: true,
                                  disabled: true,
                                }}
                              />
                            </div>
                            {/* Urgency Flag */}
                            <div
                              className="col-12 md:col-6 flex flex-column gap-2"
                              style={{ width: "48.1%" }}
                            >
                              <DropdownInputUF
                                label={intl.formatMessage({
                                  id: "urgency_flag",
                                })}
                                options={urgencyOptions}
                                value={urgencyFlag} // 0 or 1
                                onChange={setUrgencyFlag} // updates local state
                                placeholder={intl.formatMessage({
                                  id: "select_flag",
                                })}
                                required
                              />
                            </div>
                          </div>

                          {/* Date */}
                          <div className="grid">
                            <div className="col-12 md:col-6 lg:col-4">
                              <Field
                                appendTo={document.body}
                                key={`dp-${calendarKey}`}
                                name="start_date"
                                component={DatePicker}
                                label={intl.formatMessage({ id: "start_date" })}
                                placeholder={intl.formatMessage({
                                  id: "start_date_place_holder",
                                })}
                                onChange={(e) => {
                                  const date = e;

                                  setStartDate(date); // if using formik
                                }}
                                required
                                // minDate={new Date()}
                                validate={Validations.composeValidators(
                                  Validations.required
                                )}
                              />
                            </div>

                            <div className="col-12 md:col-6 lg:col-4">
                              <Field
                                timeValue={startTime}
                                name="start_time"
                                component={TextInputNoti}
                                type="time"
                                label={intl.formatMessage({ id: "start_time" })}
                                placeholder={intl.formatMessage({
                                  id: "start_time_place_holder",
                                })}
                                onChange={(value) => {
                                  setStartTime(value);
                                }} // ✅ now works
                                // step="1"                                   // ✅ show seconds
                                required
                                validate={
                                  !isCustomEdit &&
                                  Validations.composeValidators(
                                    Validations.required
                                  )
                                }
                              />
                            </div>

                            <div className="col-12 md:col-6 lg:col-4">
                              <Field
                                name="timezone"
                                component={DropdownInput}
                                label={intl.formatMessage({ id: "timezone" })}
                                options={Intl.supportedValuesOf("timeZone").map(
                                  (tz) => ({
                                    name: tz,
                                    value: tz,
                                  })
                                )}
                                placeholder={intl.formatMessage({
                                  id: "timezone",
                                })}
                                onChange={(value) => setTimezone(value)}
                                defaultValue={defaultTimezone()}
                                required
                                validate={Validations.composeValidators(
                                  Validations.required
                                )}
                                filter={true} // ✅ enables search
                                filterBy="name" // ✅ ensures it searches the "name" property
                                showClear={true} // ✅ adds "x" icon to clear
                              />
                            </div>
                          </div>
                          {/* ---------------- Checkbox ---------------- */}
                          <div className="w-full flex items-center gap-2 border p-1 rounded">
                            {" "}
                            <style>{`
        .p-checkbox .p-checkbox-box {
          width: 16px;
          height: 16px;
          border: 2px solid black;
          border-radius: 2px;
        }
        .p-checkbox .p-checkbox-box.p-highlight {
          background-color: black;
          border-color: black;
        }
        .p-checkbox .p-checkbox-box.p-highlight::after {
          border-color: white;
          border-width: 2px;
        }
      `}</style>
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                  {activeTab === 1 && (
                    <div className="p-0.5">
                      {isEditMode && !isEditable ? (
                        <div className="flex flex-column gap-3 border-round p-2 surface-card">
                          <Section title="email_template">
                            <div className="flex flex-column gap-2">
                              <div className="grid">
                                {/* Name */}
                                <div className="col-12 md:col-6 lg:col-4">
                                  <label
                                    className="text-gray-500"
                                    style={{
                                      fontColor: "#64748b",
                                      fontSize: "12px",
                                      fontWeight: "400",
                                    }}
                                  >
                                    {intl.formatMessage({ id: "subject" })}
                                  </label>
                                  <div className="text-gray-600 mt-1">
                                    {/* {apiData?.name || "-"} */}
                                    {/* {"New Cybersecurity Awareness Training Assigned"} */}
                                    {subject}
                                  </div>
                                </div>
                                <div className="col-12">
                                  <label
                                    className="text-gray-500"
                                    style={{
                                      fontColor: "#64748b",
                                      fontSize: "12px",
                                      fontWeight: "400",
                                    }}
                                  >
                                    {intl.formatMessage({ id: "body" })}
                                  </label>
                                  <div
                                    className="text-gray-600 mt-1"
                                    dangerouslySetInnerHTML={{ __html: body }}
                                  >
                                    {/* {apiData?.name || "-"} */}
                                    {/* {"Hello Judy,We’re excited to let you know that you’ve successfully completed the “Introduction to Stock Market Fundamentals” course.This is a big achievement, and we’re proud of the effort you’ve put into learning and growing your skills. You can now download your certificate and share it with your professional network.Keep going — your learning journey has just begun!Best regards,The Learning Team"} */}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </Section>
                        </div>
                      ) : (
                        <div>
                          <Section title="email_template">
                            <div className="mb-4">
                              <label
                                htmlFor="language"
                                className="block mb-1 font-medium"
                              >
                                {intl.formatMessage({ id: "select_language" })}
                              </label>

                              <Field
                                id="language"
                                name="language"
                                component={DropdownInput}
                                placeholder={intl.formatMessage({
                                  id: "select_language",
                                })}
                                initialValue={selectedLanguage}
                                options={
                                  languages && languages.length > 0
                                    ? languages.map((lang) => ({
                                        name: lang.name,
                                        value: lang.code,
                                      }))
                                    : [{ name: "", value: "" }]
                                }
                                required
                                validate={Validations.composeValidators(
                                  Validations.required
                                )}
                                style={{ width: "100%" }}
                                onChange={(value) => {
                                  handleLanguageChange(value, formikProps);
                                }} // receives langCode directly from DropdownInput
                              />
                            </div>

                            <div className="mb-4 relative">
                              <label
                                htmlFor="subject"
                                className="block mb-1 font-medium"
                              >
                                {intl.formatMessage({ id: "subject" })}
                              </label>

                              <div
                                ref={inputWrapperRef}
                                onKeyDown={handleKeyDown}
                                className="relative w-full"
                              >
                                <Field
                                  id="subject"
                                  name="subject"
                                  type="text"
                                  required={true}
                                  component={TextInputNoti}
                                  placeholder={intl.formatMessage({
                                    id: "enter_subject",
                                  })}
                                  initialValue={subject}
                                  input={{
                                    value: `${subject}`,
                                    // onChange: (e) => handleSubjectChange(e),
                                    onChange: (e) => {
                                      handleSubjectChange(e, formikProps);
                                    }, // receives langCode directly from DropdownInput
                                  }}
                                  validate={Validations.composeValidators(
                                    Validations.required
                                  )}
                                  style={{ width: "100%" }}
                                />
                              </div>

                              {showSuggestions &&
                                createPortal(
                                  <div
                                    ref={dropdownRef}
                                    style={{
                                      position: "absolute",
                                      top: dropdownPos.top, // page coords
                                      left: dropdownPos.left,
                                      width: dropdownPos.width,
                                      background: "white",
                                      border: "1px solid #ccc",
                                      borderRadius: 6,
                                      boxShadow: "0 6px 18px rgba(0,0,0,0.08)",
                                      maxHeight: 200,
                                      overflowY: "auto",
                                      zIndex: 999999,
                                    }}
                                  >
                                    {filteredSuggestions.map((sugg, index) => (
                                      <div
                                        ref={(el) =>
                                          (itemRefs.current[index] = el)
                                        }
                                        key={sugg}
                                        className={`px-3 py-2 cursor-pointer hover:bg-gray-100 ${
                                          index === highlightedIndex &&
                                          "bg-gray-100"
                                        }`}
                                        onClick={() => {
                                          selectSuggestion(sugg);
                                          // setShowSuggestions(false); // close
                                        }}
                                      >
                                        {`${sugg}`}
                                      </div>
                                    ))}
                                  </div>,
                                  document.body
                                )}
                            </div>

                            {/* Body */}
                            <div className="mb-4">
                              <label className="block mb-1 font-medium">
                                Body
                              </label>
                              {isEdit && content == null
                                  && (
                                    <div className="edexlms-language-warning justify-content-center align-items-center pb-3">
                                      <Message
                                        severity="warn"
                                        text={
                                          <span>
                                            {intl.formatMessage({ id: "InValidLanguage" })}
                                          </span>
                                        }
                                      ></Message>
                                    </div>
                                  )
                              }
                              <Editor
                                // apiKey="e93p4mqoegk96crqc6v1pidbon21e65v3w9qhz5w0z6r6b1c"
                                tinymceScriptSrc="/tinymce/tinymce.min.js"
                                onInit={(evt, editor) =>
                                  (editorRef.current = editor)
                                }
                                initialValue={body}
                                init={{
                                  height: 300,
                                  promotion: false,
                                  menubar: true,
                                  plugins: [
                                    "lists",
                                    "link",
                                    "autolink",
                                    "code",
                                    "advlist",
                                    "charmap",
                                    "searchreplace",
                                    "visualblocks",
                                    "fullscreen",
                                    "insertdatetime",
                                    "table",
                                    "help",
                                    "wordcount",
                                    // ,"fonts","format"
                                  ],

                                  toolbar:
                                    "formatselect | " +
                                    "bold italic underline strikethrough blockquote | " +
                                    "link| bullist numlist | " +
                                    "alignleft aligncenter alignright | " +
                                    // "fontselect fontfamily fontsizeselect | " +   // ✅ Added back
                                    "myLanguageDropdown |aiWriteButton | removeformat | help",
                                  license_key: "gpl",

                                  // font_family_formats:
                                  //   "Arial=arial,helvetica,sans-serif;" +
                                  //   "Courier New=courier new,courier,monospace;" +
                                  //   "Georgia=georgia,palatino,serif;" +
                                  //   "Tahoma=tahoma,arial,helvetica,sans-serif;" +
                                  //   "Times New Roman=times new roman,times,serif;" +
                                  //   "Verdana=verdana,geneva,sans-serif",

                                  block_formats:
                                    "Paragraph=p; Heading 1=h1; Heading 2=h2; Heading 3=h3",

                                  content_style:
                                    "body { font-family: Arial, sans-serif; font-size:14px }",

                                  setup: (editor) => {
                                    // ✅ Custom Language dropdown
                                    // editor.ui.registry.addMenuButton("myLanguageDropdown", {
                                    //   text: "Language",
                                    //   fetch: (callback) => {
                                    //     callback([
                                    //       { type: "menuitem", text: "Spanish", onAction: () => editor.insertContent("<strong>&lt;Spanish&gt;</strong>") },
                                    //       { type: "menuitem", text: "German", onAction: () => editor.insertContent("<strong>&lt;Deutsch&gt;</strong>") },
                                    //       { type: "menuitem", text: "Mongolian", onAction: () => editor.insertContent("<strong>&lt;Mongolian&gt;</strong>") },
                                    //       { type: "menuitem", text: "Indonesian", onAction: () => editor.insertContent("<strong>&lt;Indonesian&gt;</strong>") },
                                    //       { type: "menuitem", text: "Russian", onAction: () => editor.insertContent("<strong>&lt;Русский&gt;</strong>") }
                                    //     ]);
                                    //   }
                                    // });

                                    //                       let suggestionBox = null;

                                    // // Track caret position and show suggestions
                                    // const handleKeyUp = (e) => {
                                    //   const content = editor.getContent({ format: "text" });
                                    //   const sel = editor.selection.getRng();
                                    //   const offset = sel.startOffset;
                                    //   const textBeforeCursor = content.slice(0, offset);
                                    //   const lastChar = textBeforeCursor.slice(-1);

                                    //   // If last character is "{", show suggestions
                                    //   if (lastChar === "{") {
                                    //     const editorContainer = editor.getContainer();
                                    //     if (!suggestionBox) {
                                    //       suggestionBox = document.createElement("div");
                                    //       suggestionBox.style.position = "absolute";
                                    //       suggestionBox.style.background = "white";
                                    //       suggestionBox.style.border = "1px solid #ccc";
                                    //       suggestionBox.style.zIndex = 9999;
                                    //       suggestionBox.style.maxHeight = "150px";
                                    //       suggestionBox.style.overflowY = "auto";
                                    //       editorContainer.appendChild(suggestionBox);
                                    //     }

                                    //     suggestionBox.innerHTML = "";
                                    //     placeholders.forEach((item) => {
                                    //       const div = document.createElement("div");
                                    //       div.innerText = item;
                                    //       div.style.padding = "4px 8px";
                                    //       div.style.cursor = "pointer";
                                    //       div.onmouseenter = () => (div.style.background = "#eee");
                                    //       div.onmouseleave = () => (div.style.background = "white");
                                    //       div.onclick = () => {
                                    //         editor.selection.setRng(sel); // restore caret
                                    //         editor.insertContent(`{{${item}}}`);
                                    //         suggestionBox.style.display = "none";
                                    //       };
                                    //       suggestionBox.appendChild(div);
                                    //     });
                                    //     suggestionBox.style.display = "block";
                                    //   } else if (suggestionBox) {
                                    //     suggestionBox.style.display = "none";
                                    //   }
                                    // };

                                    // editor.on("keyup", handleKeyUp);

                                    // // Optional: hide suggestion box on click outside
                                    // document.addEventListener("click", (e) => {
                                    //   if (suggestionBox && !editor.getContainer().contains(e.target)) {
                                    //     suggestionBox.style.display = "none";
                                    //   }
                                    // });

                                    // Autocomplete for placeholders
                                    const onAction = (
                                      autocompleteApi,
                                      rng,
                                      value
                                    ) => {
                                      editor.selection.setRng(rng);
                                      editor.insertContent(value);
                                      autocompleteApi.hide();
                                    };

                                    editor.on("keydown", (e) => {
                                      const isAutocompleteOpen =
                                        editor.dom.select(".tox-autocompleter").length > 0;
                                  
                                      if (e.key === "Enter" && !isAutocompleteOpen) {
                                        e.preventDefault();
                                        editor.execCommand("InsertLineBreak"); // inserts <br>
                                        editor.execCommand("mceInsertRawHTML", false, "<br>");
                                        return false;
                                      }
                                    });

                                    editor.ui.registry.addAutocompleter(
                                      "placeholders",
                                      {
                                        trigger: "{",
                                        minChars: 0,
                                        columns: 1,
                                        fetch: (pattern) => {
                                          return new Promise((resolve) => {
                                            const results = placeholders
                                              .filter((p) =>
                                                p
                                                  .toLowerCase()
                                                  .includes(
                                                    pattern.toLowerCase()
                                                  )
                                              )
                                              .map((p) => ({
                                                type: "autocompleteitem",
                                                value: `{{${p}}}`,
                                                text: p,
                                              }));
                                            resolve(results);
                                          });
                                        },
                                        onAction: onAction,
                                      }
                                    );

                                    // AI Write button
                                    if (aiWriteAvailable) {
                                      editor.ui.registry.addButton(
                                        "aiWriteButton",
                                        {
                                          text: "AI Write",
                                          icon: "comment",
                                          tooltip: "Generate content using AI",
                                          onAction: () => runAiWrite(editor),
                                        }
                                      );
                                    }
                                  },
                                }}
                                // onEditorChange={(content, editor) => setBody(content)}
                                onBlur={(e) => {
                                  const content =
                                    editorRef.current.getContent();
                                  setBody(content);
                                }}
                              />
                              {/* {body =="" && (
  <div class="edexlms-field-error"
      style={{ color: "#d9342b" }} // only override color
  >
    Notification Body is required
                            </div>
                          </Section>
                        </div>
                      )}
                      {/* Subject */}
                            </div>
                          </Section>
                        </div>
                      )}
                    </div>
                  )}
                  {activeTab === 2 && (
                    <div className="p-4">
                      <div className="mb-3 flex items-center justify-between border p-3 rounded bg-gray-100">
                        <Checkbox
                          inputId="users"
                          checked={prePopulatedUsers.length > 0}
                          onClick={
                            isEdit == false
                              ? () => setShowUsers(true)
                              : undefined
                          }
                          onChange={(e) => {
                            if (!isEdit) {
                              setShowUsers(e.checked); // only open dialog if not in edit mode
                            }
                          }}
                          // onChange={isEditable ? () => setShowUsers(true) : undefined}
                          disabled={isEdit == true}
                        />
                        <label htmlFor="users" className="ml-2 flex-1">
                          Users{" "}
                          {isEdit && !isCustomEdit && !isClone
                            ? ""
                            : ` (${prePopulatedUsers.length})`}
                        </label>

                        {/* Select Button */}
                        {(isEdit == false || (isCustomEdit && isEditable)) && (
                          <Button
                            type="button"
                            label="Select"
                            onClick={() => setShowUsers(true)}
                            size="small"
                            className="p-button-outlined bg-white text-black border border-black hover:bg-gray-100 px-2 py-1 text-xs h-7"
                          />
                        )}
                      </div>
                      {/* User List Dialog */}
                      {(isEdit == false || isCustomEdit) && showUsers && (
                        <Dialog
                          header="All Users"
                          visible={showUsers}
                          modal
                          style={{
                            width: "60vw",
                            maxWidth: "800px",
                            position: "relative",
                          }}
                          onHide={() => setShowUsers(false)}
                          breakpoints={{ "960px": "75vw", "640px": "90vw" }}
                        >
                          <UserList
                            users={formattedUsers}
                            totalCount={totalCount}
                            query={query}
                            setQuery={setQuery}
                            fetchUsers={fetchUsers}
                            selectedUsers={selectedUsers} // ✅ pass selected users
                            setSelectedUsers={setSelectedUsers} // ✅ pass setter
                            onSave={(selectedUsers) => {
                              handleSaveTab2(selectedUsers);
                              setPrePopulatedUsers(
                                selectedUsers.map((u) => u.id)
                              );
                              setShowUsers(false);
                            }}
                            onCancel={() => setShowUsers(false)}
                            preSelectedIds={prePopulatedUsers || []}
                          />
                        </Dialog>
                      )}
                      <style>{`
        .p-checkbox .p-checkbox-box {
          width: 16px;
          height: 16px;
          border: 2px solid black;
          border-radius: 2px;
        }
        .p-checkbox .p-checkbox-box.p-highlight {
          background-color: black;
          border-color: black;
        }
        .p-checkbox .p-checkbox-box.p-highlight::after {
          border-color: white;
          border-width: 2px;
        }
      `}</style>

                      {/* Role(s) */}
                      <div className="mb-3 flex items-center justify-between border p-3 rounded bg-gray-100">
                        <Checkbox
                          inputId="roles"
                          checked={prePopulatedRoles.length > 0}
                          onChange={
                            isEdit == false ? () => setVisible(true) : undefined
                          }
                          disabled={isEdit == true}
                        />
                        <label htmlFor="roles" className="ml-2 flex-1">
                          Role
                          {isEdit && !isCustomEdit && !isClone
                            ? ""
                            : `(${prePopulatedRoles.length})`}
                        </label>

                        {/* Select Button */}
                        {(isEdit == false || (isCustomEdit && isEditable)) && (
                          <Button
                            type="button"
                            label="Select"
                            onClick={() => {
                              setVisible(true);
                            }}
                            size="small"
                            className="p-button-outlined bg-white text-black border border-black hover:bg-gray-100 px-2 py-1 text-xs h-7"
                          />
                        )}
                      </div>

                      {/* Roles Dialog */}
                      {(isEdit == false || isCustomEdit) && visible && (
                        <Dialog
                          header="All Roles"
                          visible={visible}
                          modal
                          style={{
                            width: "60vw",
                            maxWidth: "800px",
                            position: "relative",
                          }}
                          onHide={cancelRoles}
                          breakpoints={{ "960px": "75vw", "640px": "90vw" }}
                        >
                          <RoleList
                            roles={formattedRoles}
                            totalCount={totalCountRoles}
                            query={queryRole}
                            setQuery={setQueryRole}
                            fetchRoles={fetchRoles}
                            selectedRoles={selectedRoles} // ✅ pass selected users
                            setSelectedRoles={setSelectedRoles} // ✅ pass setter
                            onSave={(selectedRoles) => {
                              handleSaveTab5(selectedRoles);
                              setPrePopulatedRoles(
                                selectedRoles.map((u) => u.id)
                              );
                              setVisible(false);
                            }}
                            onCancel={cancelRoles}
                            preSelectedIds={prePopulatedRoles || []}
                          />
                        </Dialog>
                      )}
                      <style>{`
        .p-checkbox .p-checkbox-box {
          width: 16px;
          height: 16px;
          border: 2px solid black;
          border-radius: 2px;
        }
        .p-checkbox .p-checkbox-box.p-highlight {
          background-color: black;
          border-color: black;
        }
        .p-checkbox .p-checkbox-box.p-highlight::after {
          border-color: white;
          border-width: 2px;
        }
      `}</style>
                      {/* /*Cohorts  */}
                      <div className="mb-3 flex items-center justify-between border p-3 rounded bg-gray-100">
                        <Checkbox
                          inputId="cohorts"
                          checked={prePopulatedCohorts.length > 0}
                          onChange={
                            isEdit == false
                              ? () => setVisibleCoh(true)
                              : undefined
                          }
                          disabled={isEdit == true}
                        />
                        <label htmlFor="cohorts" className="ml-2 flex-1">
                          Cohorts{" "}
                          {isEdit && !isCustomEdit && !isClone
                            ? ""
                            : `(${prePopulatedCohorts.length})`}
                        </label>

                        {/* Select Button */}
                        {(isEdit == false || (isCustomEdit && isEditable)) && (
                          <Button
                            type="button"
                            label="Select"
                            onClick={() => setVisibleCoh(true)}
                            size="small"
                            className="p-button-outlined bg-white text-black border border-black hover:bg-gray-100 px-2 py-1 text-xs h-7"
                          />
                        )}
                      </div>

                      {/* Cohorts Dialog */}
                      {(isEdit == false || isCustomEdit) && visibleCoh && (
                        <Dialog
                          header="All Cohorts"
                          visible={visibleCoh}
                          modal
                          style={{
                            width: "60vw",
                            maxWidth: "800px",
                            position: "relative",
                          }}
                          onHide={cancelCohorts}
                          breakpoints={{ "960px": "75vw", "640px": "90vw" }}
                        >
                          <CohortList
                            cohorts={formattedCohorts}
                            totalCount={totalCountAud}
                            query={queryAud}
                            setQuery={setQueryAud}
                            fetchCohorts={fetchCohorts}
                            selectedCohorts={selectedCohorts} // ✅ pass selected users
                            setSelectedCohorts={setSelectedCohorts} // ✅ pass setter
                            onSave={(selectedCohorts) => {
                              handleSaveTab4(selectedCohorts);
                              setPrePopulatedCohorts(
                                selectedCohorts.map((u) => u.id)
                              );
                              setVisibleCoh(false);
                            }}
                            onCancel={cancelCohorts}
                            preSelectedIds={prePopulatedCohorts || []}
                          />
                        </Dialog>
                      )}
                      <style>{`
        .p-checkbox .p-checkbox-box {
          width: 16px;
          height: 16px;
          border: 2px solid black;
          border-radius: 2px;
        }
        .p-checkbox .p-checkbox-box.p-highlight {
          background-color: black;
          border-color: black;
        }
        .p-checkbox .p-checkbox-box.p-highlight::after {
          border-color: white;
          border-width: 2px;
        }
      `}</style>
                    </div>
                  )}

                  {activeTab === 3 && (
                    <div className="p-4">
                      <div className="flex flex-column gap-3">
                        {channelList.map((item) => {
                          // Determine if this checkbox should be always checked in edit mode
                          const isAlwaysChecked =
                            item.key === "email" ||
                            item.key === "NotificationWidgets";

                          return (
                            <div
                              key={item.key}
                              className={`flex items-center border p-3 rounded bg-gray-100 relative ${
                                item.comingSoon ? "opacity-60" : ""
                              }`}
                            >
                              <div className="flex items-center">
                                <Checkbox
                                  inputId={item.key}
                                  // Force checked for Email/Notification in edit
                                  checked={
                                    isAlwaysChecked ? true : channels[item.key]
                                  }
                                  onChange={() => {
                                    // Only toggle if not always checked and not coming soon
                                    if (!isAlwaysChecked && !item.comingSoon) {
                                      setChannels((prev) => ({
                                        ...prev,
                                        [item.key]: !prev[item.key],
                                      }));
                                    }
                                  }}
                                  disabled={isAlwaysChecked || item.comingSoon} // disable Email/Notification in edit
                                />
                                <label htmlFor={item.key} className="ml-2">
                                  {item.label}
                                </label>
                              </div>

                              {item.comingSoon && (
                                <span
                                  className="absolute right-4 text-sm text-gray-500 italic"
                                  style={{ marginLeft: "800px" }}
                                >
                                  Coming Soon
                                </span>
                              )}

                              <style>{`
              .p-checkbox .p-checkbox-box {
                width: 16px;
                height: 16px;
                border: 2px solid black;
                border-radius: 2px;
              }
              .p-checkbox .p-checkbox-box.p-highlight {
                background-color: black;
                border-color: black;
              }
              .p-checkbox .p-checkbox-box.p-highlight::after {
                border-color: white;
                border-width: 2px;
              }
            `}</style>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  )}

                  {isEditable && (
                    <div className="flex justify-content-end mt-4 gap-2">
                      <Button
                        label="Cancel"
                        className="p-button-outlined mr-2" // outlined adds border
                        onClick={() => {
                          setIsEditable(false);
                          // Reset any changes or close the form/dialog
                        }}
                      />
                      <Button type="submit" label="Update Content" />
                    </div>
                  )}
                  {isEdit == false && (
                    <div className="flex justify-content-end mt-4 gap-2">
                      {activeTab !== 0 && (
                        <Button
                          label="Previous"
                          className="p-button-outlined mr-2"
                          onClick={(e) => {
                            e.preventDefault(); // prevent form submit
                            setActiveTab(activeTab - 1);
                          }}
                        />
                      )}
                      <Button
                        label={activeTab === 3 ? "Save" : "Next"}
                        className="p-button-primary"
                        onClick={async (e) => {
                          e.preventDefault();

                          // console.log("i am reached", form.getState());
                          // Run field-level validations
                          await form.submit(); // await ensures validation finishes

                          const errors = form.getState().errors; // current form errors
                          if (
                            selectedUsers.length === 0 &&
                            selectedRoles.length === 0 &&
                            selectedCohorts.length === 0 &&
                            otherAudience.length === 0 &&
                            activeTab == 2
                          ) {
                            toast.error(
                              customIntl.formatMessage({
                                id: "validation_recipient",
                              })
                            );
                            return; // stop execution
                          }

                          if (
                            Object.keys(errors).length > 0 ||
                            notiStatus?.notiStatus?.response === true
                          ) {
                            return; // stop here, show error messages
                          }

                          // If no errors, handle tab logic
                          if (activeTab === 3) {
                            handleSaveNotification(); // final save
                          } else {
                            // Tab 0 or 1
                            // console.log(subject, "sub====>>>");
                            if (activeTab === 1 && subject !== "") {
                              addTemplateToList(formikProps);
                            }
                            setActiveTab(activeTab + 1); // move to next tab only once
                          }
                        }}
                      />
                    </div>
                  )}
                </form>
              );
            }}
          />
        </div>
      </div>
    </div>
  );
};

const mapDispatchToProps = (dispatch) => ({
  updateCustomNotiRecipant: (params) =>
    dispatch(updateCustomNotiRecipant(params)),
  GetNotificationRequest: (params) => dispatch(GetNotificationRequest(params)),
  updateNotiBasicInfo: (params) => dispatch(updateNotiBasicInfo(params)),
  updateNotificationContentRequest: (params) =>
    dispatch(updateNotificationContentRequest(params)),
  GetContentRequest: (params) => dispatch(GetContentRequest(params)),
  GetOthersCategoryRequest: (params) =>
    dispatch(GetOthersCategoryRequest(params)),
  CreateNotificationContentRequest: (params) =>
    dispatch(CreateNotificationContentRequest(params)),
  listRequest: (params) => dispatch(listRequest(params)),
  dropdownRequest: (params) => dispatch(dropdownRequest(params)),
  audienceListRequest: (params) => dispatch(audienceListRequest(params)),
  GetNotificationClone: (params) => dispatch(GetNotificationClone(params)),
  getRolesRequest: (params) => dispatch(getRolesRequest(params)),
  integrationSubtypesRequest: (params) =>
    dispatch(integrationSubtypesRequest(params)),
});

const mapStateToProps = (state) => ({
  response: state.notifications?.details,
  requesting: state.notifications.requesting,
  error: state.notifications.error,
  action: state.notifications.action,
  user: state.self?.user,
  content: state.notifications?.record,
  categoryOptions: state.notifications?.categories, // if GetOthersCategoryRequest stores data here
  newContentResponse: state.notifications?.record, // if CreateNotificationContentRequest stores response here
  listResponse: state.notifications?.list,
  roleListResponse: state.roles?.list,
  audienceListResponse: state.audiences?.list,
  updatedRecipant: state.notifications?.record,
  newUpadtedNotificationContent: state.notifications?.record,
  integrations: state.integrations?.integrations,
});

export default connect(mapStateToProps, mapDispatchToProps)(NotificationForm);
